import { type ComponentProps, type FC, type TextareaHTMLAttributes, useEffect } from "react";
import { useCharacterCount } from "@root/shared/utils/useCharacterCount";
import { TextArea } from "@root/shared/components/TextArea";
import * as styles from "./styles.css";

export type TextAreaWithWordCounterProps = Omit<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  "onChange"
> & {
  value: string;
  counterMaxLength?: number;
  size?: ComponentProps<typeof TextArea>["size"];
  handleTextAreaChange: (value: string) => void;
  hasError?: boolean;
  textAreaRef: React.RefObject<HTMLTextAreaElement>;
};

export const TextAreaWithWordCounter: FC<TextAreaWithWordCounterProps> = ({
  value,
  size,
  handleTextAreaChange,
  hasError,
  textAreaRef,
  ...rest
}) => {
  const { text, handleChange } = useCharacterCount(value ?? "");

  const combinedChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    // NOTE: <br>が含まれている場合は改行に置き換えるため
    // 具体例：メッセージテンプレート 「かんたん作成(穴埋め)」にbrタグが含まれている
    const replacedValue = event.target.value?.replace(/<br> /g, "\n");
    handleChange(replacedValue);
    if (handleTextAreaChange) {
      handleTextAreaChange(replacedValue);
    }
  };

  // valueが外部から変更された場合は以下のuseEffectで反映と再計算を行う
  useEffect(() => {
    // NOTE: <br>が含まれている場合は改行に置き換えるため
    // 具体例：メッセージテンプレート 「かんたん作成(穴埋め)」にbrタグが含まれている
    const replacedValue = value?.replace(/<br> /g, "\n");
    handleChange(replacedValue ?? "");
  }, [handleChange, value]);

  return (
    <div className={styles.textareaWrapper}>
      <TextArea
        {...rest}
        id="form_client_frontend_premium_scout_notice_point_free_text"
        name="form_client_frontend_premium_scout[notice_point_free_text]"
        className="js-word-count js-notice-point" // React外のJS操作が残っているため
        value={text}
        size={size}
        ref={textAreaRef}
        onChange={combinedChangeHandler}
        hasError={hasError}
      />
    </div>
  );
};
